import { all, call, CallEffect, fork, put, PutEffect, takeEvery, } from "redux-saga/effects";
import { ActionTypes } from "../../constants/ActionTypes";
import { fetchError } from "../actions/Common";
import { fetchLetterReferTypesSuccess, onSendReferSuccess, fetchLetterReferSendTypesSuccess, fetchReceiversForReplySuccess, onFastReferSuccess, onUploadReferFileSuccess, onRemoveReferFileSuccess } from "../actions";
import { ShowSuccess, ShowError } from "../../helper/Alert";
import { IReplyForAllPrams } from "../../interfaces";
import { goBack } from 'connected-react-router';
import { IUploadReferFile, IRemoveReferFile } from "../../interfaces/Assign";
import faMessage from "../../../src/lngProvider/locales/fa_IR.json";
import enMessage from "../../../src/lngProvider/locales/en_US.json";
import { defineMessages } from "react-intl";
import FaraGostarDynamicHttp from "../../api/FaraGostarDynamicHttp";
import { AxiosResponse } from "axios";

const getLetterReferTypes = async () => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`refer/getLetterReferTypes`);
}

const getReceiversForReply = async (parameters: IReplyForAllPrams) => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`person/getReceiversForReply?letterCode=${parameters.letterCode}&replyToAll=${parameters.toAll}`);
}

const getLetterReferSendTypes = async () => {
    let http = await FaraGostarDynamicHttp();
    return await http.get(`refer/getLetterReferSendTypes`);
}

const sendRefer = async (parameters: any) => {
    let http = await FaraGostarDynamicHttp();
    await http.post("refer/send", parameters);
}

const fastRefer = async (parameters: any) => {
    let http = await FaraGostarDynamicHttp();
    return await http.post("refer/fastRefer", parameters);
}

const uploadReferFile = async (params: IUploadReferFile) => {
    const fd = new FormData();
    fd.append("file", params.file);
    let http = await FaraGostarDynamicHttp();
    return await http.post(`refer/UploadReferFile?uploadTaskId=${params.uploadTaskId}&groupId=${params.groupId}&key=${params.key}`,
        fd, {
        headers: {
            "content-type": "multipart/form-data",
        }
    });
}

const removeReferFile = async (params: IRemoveReferFile) => {
    let http = await FaraGostarDynamicHttp();
    return await http.post(`refer/RemoveReferFile`, params);
}

//FAST REFER
function* onFastReferRequest(action: any) {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    try {
        // const result = yield call(fastRefer, action.payload);
        yield call(fastRefer, action.payload.fastReferModel);
        // yield put(onFastReferSuccess());
        ShowSuccess(messages["messages.FastForwardWasSuccessfully"], "");
        if (action.payload.fromBody == false) {
            yield put(goBack());
            yield put(goBack());
        }
    } catch (error) {
        return ShowError("", error);
    }
}

export function* FastReferRequest() {
    yield takeEvery(ActionTypes.FAST_REFER, onFastReferRequest);
}

function* onSendReferRequest(action: any) {
    const LocaleMessages = localStorage.getItem("language") === 'fa-IR' ? faMessage : enMessage;
    const messages = defineMessages(LocaleMessages);
    try {
        // const result = yield call(sendRefer, action.payload);
        yield call(sendRefer, action.payload);
        yield put(onSendReferSuccess());
        ShowSuccess(messages["messages.ForwardWasSuccessfully"], "");
        yield put(goBack())
        yield put(goBack())
    } catch (error) {
        return ShowError("", error);
    }
}

export function* sendReferRequest() {
    yield takeEvery(ActionTypes.SEND_REFER, onSendReferRequest);
}

//PersonalArchiveForders
function* fetchLetterReferTypesRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedLetterReferTypes = yield call(getLetterReferTypes);
        yield put(fetchLetterReferTypesSuccess(fetchedLetterReferTypes.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchLetterReferTypes() {
    yield takeEvery(ActionTypes.GET_LETTER_REFER_TYPES, fetchLetterReferTypesRequest);
}

function* fetchReceiversForReplyRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedReceiversForReply = yield call(getReceiversForReply, action.payload);
        yield put(fetchReceiversForReplySuccess(fetchedReceiversForReply.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchReceiversForReply() {
    yield takeEvery(ActionTypes.GET_RECEIVERS_FOR_REPLY, fetchReceiversForReplyRequest);
}

function* fetchLetterReferSendTypesRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const fetchedLetterReferSendTypes = yield call(getLetterReferSendTypes);
        yield put(fetchLetterReferSendTypesSuccess(fetchedLetterReferSendTypes.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* fetchLetterReferSendTypes() {
    yield takeEvery(ActionTypes.GET_LETTER_REFER_SEND_TYPES, fetchLetterReferSendTypesRequest);
}

//UPLOAD REFER FILE
function* onUploadReferFileRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const uploadReferFileSuccessResponse = yield call(uploadReferFile, action.payload);
        yield put(onUploadReferFileSuccess(uploadReferFileSuccessResponse.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* onUploadReferFile() {
    yield takeEvery(ActionTypes.UPLOAD_REFER_FILE, onUploadReferFileRequest);
}

function* onRemoveReferFileRequest(action: any): Generator<CallEffect<AxiosResponse<any>> | PutEffect<{ type: ActionTypes; payload: any; }>, void, AxiosResponse<any>> {
    try {
        const removeReferFileSuccessResponse = yield call(removeReferFile, action.payload);
        yield put(onRemoveReferFileSuccess(removeReferFileSuccessResponse.data));
    } catch (error) {
        return ShowError("", error);
    }
}

export function* onRemoveReferFile() {
    yield takeEvery(ActionTypes.REMOVE_REFER_FILE, onRemoveReferFileRequest);
}

export default function* rootSaga() {
    yield all([
        fork(fetchLetterReferTypes),
        fork(sendReferRequest),
        fork(fetchLetterReferSendTypes),
        fork(fetchReceiversForReply),
        fork(FastReferRequest),
        fork(onUploadReferFile),
        fork(onRemoveReferFile)
    ])
}

